import PropTypes from 'prop-types';
import './light-loader.scss';

const LightLoader = ({ size, color, style }) => (
    <div className="bk-light-loader" style={style}>
        <div style={{ width: size, height: size, backgroundColor: color }} className="bounce1" />
        <div style={{ width: size, height: size, backgroundColor: color }} className="bounce2" />
        <div style={{ width: size, height: size, backgroundColor: color }} className="bounce3" />
    </div>
);

LightLoader.propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.object,
};

export default LightLoader;
